import React, { useState } from "react";
import {
  Card,
  CardHeader,
  LinearProgress
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import PermissionService from '../../../../../services/PermissionsService';
import { useDispatch } from "react-redux";
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { showSnackBar } from "../../../../../redux/actions/ui";


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: "1em"
  },
  collapse: {
    borderTop: "1px solid"
  }
}));


const stylesCheckBox = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(0),
    marginLeft: theme.spacing(1),
  },
}));


function PermissionItem(props) {
  const dispatch = useDispatch();

  const { loading = false } = props;    
  const { id, course, can_upload_audio, can_upload_files, can_upload_images, can_upload_video } = props.data || {};
  const classes = useStyles();
  const stylesCheckBoxClasses = stylesCheckBox();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const onChangePermission = async (event) => {
    setIsLoadingSubmit(true);
    try {
      const data = { [event.target.name]: event.target.checked }
      await PermissionService.updatePermission(data, id, course.id);
      await props.onUpdatePermission(id, data);      
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("Successfully!"));
    } catch (error) {
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }
  };

  return (
    <Card className={classes.root}>
      {/* Course header */}
      <CardHeader
        title={
          loading ? (
            <Skeleton
              variant="rect"
              width={180}
              height={20}
              style={{ marginBottom: 6 }}
            />
          ) : (
            course.name
          )
        }
        subheader={
          loading ? (
            <Skeleton variant="rect" width={210} height={10} />            
          ) : (
            <FormControl component="fieldset" className={stylesCheckBoxClasses.formControl}>
              <FormGroup row>
                <FormControlLabel
                  control={<Checkbox checked={can_upload_audio} onChange={onChangePermission} name="can_upload_audio" color="primary"/>}
                  label="Audio"
                />
                <FormControlLabel
                  control={<Checkbox checked={can_upload_video}  onChange={onChangePermission} name="can_upload_video" color="primary"/>}
                  label="Video"
                />
                <FormControlLabel
                  control={<Checkbox checked={can_upload_images} onChange={onChangePermission} name="can_upload_images" color="primary"/>}
                  label="Photo"
                />
                <FormControlLabel
                  control={<Checkbox checked={can_upload_files} onChange={onChangePermission} name="can_upload_files" color="primary"/>}
                  label="Files"
                />
              </FormGroup>
            </FormControl>
          )
        }
      />
      
      {/* Loading */}
      {isLoadingSubmit && <LinearProgress />}      
    </Card>
  );
}

export default PermissionItem;
